import React from 'react'
import {
  Beta,
  IconChevronLeftDefault,
  IconChevronRightDefault,
} from '../../components'

type CarouselClassicProps = {
  srLabel: string
} & React.ComponentProps<typeof Beta.CarouselV2.CarouselContent>

export const CarouselClassic = ({
  srLabel,
  ...props
}: CarouselClassicProps) => (
  <Beta.CarouselV2.Carousel srLabel={srLabel}>
    <Beta.CarouselV2.CarouselArrows>
      <Beta.CarouselV2.CarouselPrevious kind='secondary' symmetrical rounded>
        <IconChevronLeftDefault />
      </Beta.CarouselV2.CarouselPrevious>
      <Beta.CarouselV2.CarouselContent {...props} />
      <Beta.CarouselV2.CarouselNext kind='secondary' symmetrical rounded>
        <IconChevronRightDefault />
      </Beta.CarouselV2.CarouselNext>
    </Beta.CarouselV2.CarouselArrows>
    <Beta.CarouselV2.CarouselPages />
  </Beta.CarouselV2.Carousel>
)
